import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { ApiCrearComida, ApiEditarComida } from "../../../api/comidas";
import { socket } from "../../../config/socket";
const CrearComidas = ({
  updateListFn,
  state,
  setState,
  type,
  setType,
  resetState,
}) => {
  const [loading, setLoading] = useState(false);
  const fields = [
    { name: "nombre", label: "Nombre de la Comida" },
    { name: "costo", label: "Costo" },
    { name: "hora_inicio", label: "Hora de inicio" },
    { name: "hora_fin", label: "Hora de Fin" },
  ];

  const onchange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  // SCOCKET REAL TIME
  useEffect(() => {
    // Conectar
    //socket.connect();
    if (!socket.connected) {
      socket.connect();
    }

    socket.emit("join:ticket", "ticketPeriodos");

    // Cleanup
    return () => {
      socket.disconnect();
    };
  }, []);

  const emptyFields = fields.filter((campo) => !state[campo.name]);
  const CrearFn = async () => {
    setLoading(true);
    if (emptyFields.length > 0) {
      const mensajes = emptyFields.map(
        (campo) => `El campo "${campo.label}" no puede estar vacío.`
      );
      const mensajeError = mensajes.join("\n");
      toast.error(mensajeError, {
        position: "bottom-center",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
      setLoading(false);
      return;
    }

    const res =
      type === "save"
        ? await ApiCrearComida(state)
        : await ApiEditarComida(state);
    const datares = res;
    if (datares.sms === "ok") {
      toast.success(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      socket.emit("ticket:update", {
        sala: "ticketPeriodos",
      });
      setType("save");
      resetState();
      updateListFn();
    } else {
      toast.error(datares.mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="row mt-3 mb-4">
        <div className="col-md-6 col-lg-4  w-100">
          <div
            className=" bg-white  border-0 borde-tarjeta"
            style={{ height: "auto" }}
          >
            <div className="card-body m-0 p-0">
              <div className="w-100 bgfondo2 bordeabajo bordesombreado d-flex flex-column align-items-center d-flex justify-content-center py-3 px-3">
                <div className="w-100  d-flex justify-content-between align-items-center px-3">
                  <h5 className=" negrita card-title">
                    {type === "save" ? "Crear" : "Editar"} Comida
                  </h5>
                  <div className="d-flex justify-content-between flex-row align-self-start">
                    <div className="d-flex justify-content-end ">
                      {loading ? (
                        <div className="spinner-border" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        <button
                          type=""
                          className="bg-btn-vet bordesombreado"
                          onClick={() => CrearFn()}
                        >
                          <i className="fas fa-save mx-2"></i>
                          {type === "save" ? "Guardar" : "Editar"} Comida
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row py-4 ">
                <div className="col-md-6">
                  <label className="py-2 negrita">Nombre de la Comida</label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={state.nombre}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el nombre de la comida"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Costo</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    id="costo"
                    name="costo"
                    value={state.costo}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite el costo de la comida"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Hora de inicio</label>
                  <input
                    type="time"
                    id="hora_inicio"
                    name="hora_inicio"
                    value={state.hora_inicio}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite la hora de inicio"
                    onChange={onchange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="py-2 negrita">Hora de fin</label>
                  <input
                    type="time"
                    id="hora_fin"
                    name="hora_fin"
                    value={state.hora_fin}
                    className="inputtext2 bordecompleto"
                    placeholder="Digite la hora de fin"
                    onChange={onchange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrearComidas;
